import React from 'react';
import { useSelector } from 'react-redux';
import Checkout from './Checkout';
import DirectSaleCheckout from './DirectSaleCheckout';
import { ShopMode } from '../../redux/types';

export const CheckoutWrapper: React.FC = () => {
  const shopMode = useSelector((state: any) => state.shopMode.mode);

  return shopMode === ShopMode.DirectSale ? <DirectSaleCheckout /> : <Checkout />;
};
